import {
  NBS_API_GET_SUBSCRIPTIONS_LIST_REQUEST,
  NBS_API_GET_SUBSCRIPTIONS_LIST_SUCCESS,
  NBS_API_GET_SUBSCRIPTIONS_LIST_FAILURE
} from '../../constants/actions';
import { prepareSubscriptionList } from '../../assets/helpers/upgradeHelper';

const initialState = {
  isFetching: null,
  error: null,
  timestamp: null,
  response: {},
  status: null,
  preparedList: []
};

export default function reducer (state = initialState, action = {}) {
  switch (action.type) {
    case NBS_API_GET_SUBSCRIPTIONS_LIST_REQUEST:
      return {
        ...state,
        isFetching: true,
        error: false,
        response: {},
        timestamp: new Date().toUTCString(),
        status: 'request',
        preparedList: []
      };
    case NBS_API_GET_SUBSCRIPTIONS_LIST_SUCCESS:
      return {
        ...state,
        isFetching: false,
        error: false,
        response: action.response,
        // response: { success: true, list: [] },
        timestamp: new Date().toUTCString(),
        status: 'success',
        preparedList: action.response.list && action.response.list.length > 0 ? prepareSubscriptionList(action.response.list) : []
       //  preparedList: []
      };
    case NBS_API_GET_SUBSCRIPTIONS_LIST_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.error,
        response: {},
        timestamp: new Date().toUTCString(),
        status: 'fail',
        preparedList: []
      };
    default:
      return state;
  }
}
